import { types } from "../types/types";

export const updateSpinner = (value) => ({
    type: types.showSpinner,
    payload: value
});